import { Cartesian3, CustomDataSource, Color, Entity, PropertyBag, Billboard, BillboardCollection } from 'cesium';
import { education } from '../Resume/Education.tsx';
export function createEduSource(): CustomDataSource {
        let eduSource = new CustomDataSource();
        let locations = new Map<string, Entity>();
        for (const degree of education) {
            for (const address of degree.addresses) {
                let key = JSON.stringify(address.coords);
                if (locations.has(key)) {
                    (locations.get(key) as any).degrees.push(degree);
                    continue;
                }

                const img = new Image();
                img.src = degree.logoImg;
                let ent = eduSource.entities.add({
                    point: {
                        color: Color.WHITE,
                        pixelSize: 10,
                        outlineColor: Color.WHITE,
                        outlineWidth: 2,
                    },
                    position: Cartesian3.fromDegrees(address.coords.lon, address.coords.lat),
                    properties: new PropertyBag(),
                });
                let eduArray = [degree];
                ent.addProperty("degrees");
                (ent as any).degrees = eduArray;
                locations.set(key, ent);
                img.onload = () => {
                    const ar = img.naturalWidth / img.naturalHeight;
                    const height = 30;
                    const width = height * ar;
                    ent.billboard = new Billboard({
                        image: degree.logoImg,
                        height,
                        width,
                        verticalOrigin: 1,
                    } as Billboard.ConstructorOptions, new BillboardCollection()) as any;
                }
            }
        }
        return eduSource;
}
